// breakwater-fe/src/actions/CommentActions.js
import { listComments, createComment as backendCreateComment, updateComment as backendUpdateComment, deleteComment as backendDeleteComment } from '../Backend';

export const LOAD_COMMENTS          = 'LOAD_COMMENTS';
export const LOAD_COMMENTS_SUCCESS  = 'LOAD_COMMENTS_SUCCESS';
export const LOAD_COMMENTS_FAIL     = 'LOAD_COMMENTS_FAIL';

export const CREATE_COMMENT         = 'CREATE_COMMENT';
export const CREATE_COMMENT_SUCCESS = 'CREATE_COMMENT_SUCCESS';
export const CREATE_COMMENT_FAIL    = 'CREATE_COMMENT_FAIL';

export const UPDATE_COMMENT         = 'UPDATE_COMMENT';
export const UPDATE_COMMENT_SUCCESS = 'UPDATE_COMMENT_SUCCESS';
export const UPDATE_COMMENT_FAIL    = 'UPDATE_COMMENT_FAIL';

export const DELETE_COMMENT         = 'DELETE_COMMENT';
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS';
export const DELETE_COMMENT_FAIL    = 'DELETE_COMMENT_FAIL';

const parentKey = (type, id) => `${type}:${id}`;

export const fetchComments = (parentType, parentId) => async (dispatch) => {
  dispatch({ type: LOAD_COMMENTS, parentKey: parentKey(parentType, parentId) });
  try {
    const res = await listComments(parentType, parentId);
    const json = await res.json();
    if (!res.ok) throw new Error(json.error || 'failed');
    dispatch({ type: LOAD_COMMENTS_SUCCESS, parentKey: parentKey(parentType, parentId), comments: json });
  } catch (e) {
    dispatch({ type: LOAD_COMMENTS_FAIL, parentKey: parentKey(parentType, parentId), error: e.message });
  }
};

export const createComment = (parentType, parentId, body) => async (dispatch) => {
  dispatch({ type: CREATE_COMMENT, parentKey: parentKey(parentType, parentId) });
  try {
    const res = await backendCreateComment(parentType, parentId, body);
    const json = await res.json();
    if (!res.ok) throw new Error((json.errors && json.errors.join(', ')) || 'failed');
    dispatch({ type: CREATE_COMMENT_SUCCESS, parentKey: parentKey(parentType, parentId), comment: json });
    return true;
  } catch (e) {
    dispatch({ type: CREATE_COMMENT_FAIL, parentKey: parentKey(parentType, parentId), error: e.message });
    return false;
  }
};

export const updateComment = (parentType, parentId, commentId, body) => async (dispatch) => {
  dispatch({ type: UPDATE_COMMENT, parentKey: parentKey(parentType, parentId) });
  try {
    const res = await backendUpdateComment(commentId, body);
    const json = await res.json();
    if (!res.ok) throw new Error((json.errors && json.errors.join(', ')) || 'failed');
    dispatch({ type: UPDATE_COMMENT_SUCCESS, parentKey: parentKey(parentType, parentId), comment: json });
    return true;
  } catch (e) {
    dispatch({ type: UPDATE_COMMENT_FAIL, parentKey: parentKey(parentType, parentId), error: e.message });
    return false;
  }
};

export const deleteComment = (parentType, parentId, commentId) => async (dispatch) => {
  dispatch({ type: DELETE_COMMENT, parentKey: parentKey(parentType, parentId) });
  try {
    const res = await backendDeleteComment(commentId);
    if (!res.ok && res.status !== 204) {
      const json = await res.json().catch(() => ({}));
      throw new Error(json.error || 'failed');
    }
    dispatch({ type: DELETE_COMMENT_SUCCESS, parentKey: parentKey(parentType, parentId), commentId });
    return true;
  } catch (e) {
    dispatch({ type: DELETE_COMMENT_FAIL, parentKey: parentKey(parentType, parentId), error: e.message });
    return false;
  }
};
